<style lang="less" scoped>
.swiperYSZT{position: relative;width:1200px;overflow:hidden;}
.seamless-warp{width: 1200px;height: 320px;overflow: hidden;}
ul{list-style: none;display: flex;}
li{width: 240px;height:280px;overflow: hidden;margin: 0px 10px;cursor: pointer;background: rgb(243, 241, 241);transition: transform .5s;}
img{width:240px;height:200px;}
li:hover {transform: scaleY(1.2);p{transform: scaleY(1/1.2)}}
</style>

<!-- 何宽 2021.9.10
     该组件使用场景：自动轮播一组图片，鼠标移入高度变高，点击图片或标题，将 整个对象 传递给父组件 -->
<template>
  <div class="swiperYSZT">
    <vue-seamless-scroll :data="swiperYSZTList" class="seamless-warp" :class-option="optionLeft">
      <ul>
        <li class="DataList_left" v-for="(item,index) in swiperYSZTList" :key="index" @click="clickSwiperYSZT(item.name)">
          <img class="pic" :src="item.pic" />
          <p>
            <span style="font-size: 24px;font-weight:600;color:rgb(9, 197, 9);margin-left:-60px;">{{ item.type }}</span>
            <span style="font-size: 20px;margin-left:10px;">{{ item.title }}</span>
          </p>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  props: ['swiperYSZTList'],
  components:
  {
    vueSeamlessScroll
  },
  data()
  {
    return {
    }
  },
  computed:
  {
    optionLeft()
    {
      return {
        step: 0.8,
        direction: 2
      }
    }
  },
  // 点击图片或图片标题，将该图片对象传递给父组件
  methods: {
    clickSwiperYSZT(name)
    {
      this.$emit('clickSwiperYSZT', name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/SwiperYSZT.vue